(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					this.header.classList.add('color-background-overlay-hidden');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					this.header.classList.remove('color-background-overlay-hidden');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true); 
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-ab-new"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();

      if (this.openedBy) this.openedBy.blur();
    }

    show(opener) {
      super.show(opener);
      this.syncActiveGallery();
      this.showActiveMedia();
    }

    // Find which gallery is currently active in the main product area
    getActiveMainGallery() {
      return document.querySelector('.product__media-wrapper .js-media-list-ab-test:not(.hidden)');
    }

    // Show the popup slider that matches the active main gallery; init its Swiper if needed
    syncActiveGallery() {
      const activeMainGallery = this.getActiveMainGallery();
      const popupSliders = Array.from(this.querySelectorAll('.js-popup-slider'));

      // Hide all popup sliders
      popupSliders.forEach(s => s.classList.add('hidden'));

      let targetPopup = null;

      if (activeMainGallery) {
        const galleryId = activeMainGallery.dataset.jsMediaListId;
        targetPopup = this.querySelector(`.js-popup-slider[data-js-media-list-id="${galleryId}"]`);
      }

      if (!targetPopup) {
        targetPopup = this.querySelector('.js-popup-slider-default');
      }

      if (!targetPopup) return;

      targetPopup.classList.remove('hidden');
      this.initPopupSlider(targetPopup, activeMainGallery);
    }

    initPopupSlider(elem, mainGallery) {
      if (elem.swiper) {
        elem.swiper.update();
        if (mainGallery && mainGallery.swiper) {
          elem.swiper.slideTo(mainGallery.swiper.activeIndex, 0);
        }
        return;
      }

      new Swiper(elem, {
        slidesPerView: 1,
        navigation: {
          nextEl: '.product-media-modal .product__slider-nav .swiper-button-next',
          prevEl: '.product-media-modal .product__slider-nav .swiper-button-prev',
        },
        pagination: {
          el: '.product-media-modal .product__pagination',
          type: 'bullets',
          clickable: true,
        },
        on: {
          afterInit: (swiper) => {
            if (mainGallery && mainGallery.swiper) {
              swiper.slideTo(mainGallery.swiper.activeIndex, 0);
            }
          },
          slideChange: function() {
            window.pauseAllMedia();
            this.params.noSwiping = false;
            this.el.classList.remove('zoom');
          },
          touchMove: function() {
            this.el.classList.remove('zoom');
          },
          slideChangeTransitionEnd: function() {
            const modelViewer = this.slides[this.activeIndex]?.querySelector('model-viewer');
            if (modelViewer) {
              modelViewer.querySelector('.shopify-model-viewer-ui__button--poster')?.removeAttribute('hidden');
            }
          },
          touchStart: function() {
            const modelViewer = this.slides[this.activeIndex]?.querySelector('model-viewer');
            if (modelViewer) {
              this.params.noSwiping = !modelViewer.classList.contains('shopify-model-viewer-ui__disabled');
              this.params.noSwipingClass = 'swiper-slide';
            }
          },
        },
      });
    }

    showActiveMedia() {
      const mediaId = this.openedBy.getAttribute('data-media-id');
      const activePopup = this.querySelector('.js-popup-slider:not(.hidden)');
      if (!activePopup || !activePopup.swiper) return;

      // Scroll popup to the clicked image's slide
      const imgEl = activePopup.querySelector(`[data-media-id="${mediaId}"]`);
      if (imgEl) {
        const slideEl = imgEl.closest('.swiper-slide');
        if (slideEl) {
          const index = Array.from(activePopup.swiper.slides).indexOf(slideEl);
          if (index >= 0) activePopup.swiper.slideTo(index, 0);
        }
      }

      // Load deferred YouTube media if needed
      const deferredMedia = activePopup.querySelector(`deferred-media[data-media-id="${mediaId}"]`);
      if (deferredMedia && deferredMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        deferredMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-ab"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();

      if (this.openedBy) this.openedBy.blur();
    }

    show(opener) {
      super.show(opener);
      this.syncActiveGallery();
      this.showActiveMedia();
    }

    // Find which gallery is currently active in the main product area
    getActiveMainGallery() {
      return document.querySelector('.product__media-wrapper .js-media-list-ab-test:not(.hidden)');
    }

    // Show the popup slider that matches the active main gallery; init its Swiper if needed
    syncActiveGallery() {
      const activeMainGallery = this.getActiveMainGallery();
      const popupSliders = Array.from(this.querySelectorAll('.js-popup-slider'));

      // Hide all popup sliders
      popupSliders.forEach(s => s.classList.add('hidden'));

      let targetPopup = null;

      if (activeMainGallery) {
        const galleryId = activeMainGallery.dataset.jsMediaListId;
        targetPopup = this.querySelector(`.js-popup-slider[data-js-media-list-id="${galleryId}"]`);
      }

      if (!targetPopup) {
        targetPopup = this.querySelector('.js-popup-slider-default');
      }

      if (!targetPopup) return;

      targetPopup.classList.remove('hidden');
      this.initPopupSlider(targetPopup, activeMainGallery);
    }

    initPopupSlider(elem, mainGallery) {
      if (elem.swiper) {
        elem.swiper.update();
        if (mainGallery && mainGallery.swiper) {
          elem.swiper.slideTo(mainGallery.swiper.activeIndex, 0);
        }
        return;
      }

      new Swiper(elem, {
        slidesPerView: 1,
        navigation: {
          nextEl: '.product-media-modal .product__slider-nav .swiper-button-next',
          prevEl: '.product-media-modal .product__slider-nav .swiper-button-prev',
        },
        pagination: {
          el: '.product-media-modal .product__pagination',
          type: 'bullets',
          clickable: true,
        },
        on: {
          afterInit: (swiper) => {
            if (mainGallery && mainGallery.swiper) {
              swiper.slideTo(mainGallery.swiper.activeIndex, 0);
            }
          },
          slideChange: function() {
            window.pauseAllMedia();
            this.params.noSwiping = false;
            this.el.classList.remove('zoom');
          },
          touchMove: function() {
            this.el.classList.remove('zoom');
          },
          slideChangeTransitionEnd: function() {
            const modelViewer = this.slides[this.activeIndex]?.querySelector('model-viewer');
            if (modelViewer) {
              modelViewer.querySelector('.shopify-model-viewer-ui__button--poster')?.removeAttribute('hidden');
            }
          },
          touchStart: function() {
            const modelViewer = this.slides[this.activeIndex]?.querySelector('model-viewer');
            if (modelViewer) {
              this.params.noSwiping = !modelViewer.classList.contains('shopify-model-viewer-ui__disabled');
              this.params.noSwipingClass = 'swiper-slide';
            }
          },
        },
      });
    }

    showActiveMedia() {
      const mediaId = this.openedBy.getAttribute('data-media-id');
      const activePopup = this.querySelector('.js-popup-slider:not(.hidden)');
      if (!activePopup || !activePopup.swiper) return;

      // Scroll popup to the clicked image's slide
      const imgEl = activePopup.querySelector(`[data-media-id="${mediaId}"]`);
      if (imgEl) {
        const slideEl = imgEl.closest('.swiper-slide');
        if (slideEl) {
          const index = Array.from(activePopup.swiper.slides).indexOf(slideEl);
          if (index >= 0) activePopup.swiper.slideTo(index, 0);
        }
      }

      // Load deferred YouTube media if needed
      const deferredMedia = activePopup.querySelector(`deferred-media[data-media-id="${mediaId}"]`);
      if (deferredMedia && deferredMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        deferredMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-gift"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.syncActiveGallery();
      this.showActiveMedia();
    }

    // Find which gallery is currently active in the main product area
    getActiveMainGallery() {
      return document.querySelector('.product__media-wrapper .js-media-list-ab-test:not(.hidden)');
    }

    // Show the popup slider that matches the active main gallery; init its Swiper if needed
    syncActiveGallery() {
      const activeMainGallery = this.getActiveMainGallery();
      const popupSliders = Array.from(this.querySelectorAll('.js-popup-slider'));

      // Hide all popup sliders
      popupSliders.forEach(s => s.classList.add('hidden'));

      let targetPopup = null;

      if (activeMainGallery) {
        const galleryId = activeMainGallery.dataset.jsMediaListId;
        targetPopup = this.querySelector(`.js-popup-slider[data-js-media-list-id="${galleryId}"]`);
      }

      if (!targetPopup) {
        targetPopup = this.querySelector('.js-popup-slider-default');
      }

      if (!targetPopup) return;

      targetPopup.classList.remove('hidden');
      this.initPopupSlider(targetPopup, activeMainGallery);
    }

    initPopupSlider(elem, mainGallery) {
      if (elem.swiper) {
        elem.swiper.update();
        if (mainGallery && mainGallery.swiper) {
          elem.swiper.slideTo(mainGallery.swiper.activeIndex, 0);
        }
        return;
      }

      new Swiper(elem, {
        slidesPerView: 1,
        navigation: {
          nextEl: '.product-media-modal .product__slider-nav .swiper-button-next',
          prevEl: '.product-media-modal .product__slider-nav .swiper-button-prev',
        },
        pagination: {
          el: '.product-media-modal .product__pagination',
          type: 'bullets',
          clickable: true,
        },
        on: {
          afterInit: (swiper) => {
            if (mainGallery && mainGallery.swiper) {
              swiper.slideTo(mainGallery.swiper.activeIndex, 0);
            }
          },
          slideChange: function() {
            window.pauseAllMedia();
            this.params.noSwiping = false;
            this.el.classList.remove('zoom');
          },
          touchMove: function() {
            this.el.classList.remove('zoom');
          },
          slideChangeTransitionEnd: function() {
            const modelViewer = this.slides[this.activeIndex]?.querySelector('model-viewer');
            if (modelViewer) {
              modelViewer.querySelector('.shopify-model-viewer-ui__button--poster')?.removeAttribute('hidden');
            }
          },
          touchStart: function() {
            const modelViewer = this.slides[this.activeIndex]?.querySelector('model-viewer');
            if (modelViewer) {
              this.params.noSwiping = !modelViewer.classList.contains('shopify-model-viewer-ui__disabled');
              this.params.noSwipingClass = 'swiper-slide';
            }
          },
        },
      });
    }

    showActiveMedia() {
      const mediaId = this.openedBy.getAttribute('data-media-id');
      const activePopup = this.querySelector('.js-popup-slider:not(.hidden)');
      if (!activePopup || !activePopup.swiper) return;

      // Scroll popup to the clicked image's slide
      const imgEl = activePopup.querySelector(`[data-media-id="${mediaId}"]`);
      if (imgEl) {
        const slideEl = imgEl.closest('.swiper-slide');
        if (slideEl) {
          const index = Array.from(activePopup.swiper.slides).indexOf(slideEl);
          if (index >= 0) activePopup.swiper.slideTo(index, 0);
        }
      }

      // Load deferred YouTube media if needed
      const deferredMedia = activePopup.querySelector(`deferred-media[data-media-id="${mediaId}"]`);
      if (deferredMedia && deferredMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        deferredMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-mat"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.syncActiveGallery();
      this.showActiveMedia();
    }

    // Find which gallery is currently active in the main product area
    getActiveMainGallery() {
      return document.querySelector('.product__media-wrapper .js-media-list-ab-test:not(.hidden)');
    }

    // Show the popup slider that matches the active main gallery; init its Swiper if needed
    syncActiveGallery() {
      const activeMainGallery = this.getActiveMainGallery();
      const popupSliders = Array.from(this.querySelectorAll('.js-popup-slider'));

      // Hide all popup sliders
      popupSliders.forEach(s => s.classList.add('hidden'));

      let targetPopup = null;

      if (activeMainGallery) {
        const galleryId = activeMainGallery.dataset.jsMediaListId;
        targetPopup = this.querySelector(`.js-popup-slider[data-js-media-list-id="${galleryId}"]`);
      }

      if (!targetPopup) {
        targetPopup = this.querySelector('.js-popup-slider-default');
      }

      if (!targetPopup) return;

      targetPopup.classList.remove('hidden');
      this.initPopupSlider(targetPopup, activeMainGallery);
    }

    initPopupSlider(elem, mainGallery) {
      if (elem.swiper) {
        elem.swiper.update();
        if (mainGallery && mainGallery.swiper) {
          elem.swiper.slideTo(mainGallery.swiper.activeIndex, 0);
        }
        return;
      }

      new Swiper(elem, {
        slidesPerView: 1,
        navigation: {
          nextEl: '.product-media-modal .product__slider-nav .swiper-button-next',
          prevEl: '.product-media-modal .product__slider-nav .swiper-button-prev',
        },
        pagination: {
          el: '.product-media-modal .product__pagination',
          type: 'bullets',
          clickable: true,
        },
        on: {
          afterInit: (swiper) => {
            if (mainGallery && mainGallery.swiper) {
              swiper.slideTo(mainGallery.swiper.activeIndex, 0);
            }
          },
          slideChange: function() {
            window.pauseAllMedia();
            this.params.noSwiping = false;
            this.el.classList.remove('zoom');
          },
          touchMove: function() {
            this.el.classList.remove('zoom');
          },
          slideChangeTransitionEnd: function() {
            const modelViewer = this.slides[this.activeIndex]?.querySelector('model-viewer');
            if (modelViewer) {
              modelViewer.querySelector('.shopify-model-viewer-ui__button--poster')?.removeAttribute('hidden');
            }
          },
          touchStart: function() {
            const modelViewer = this.slides[this.activeIndex]?.querySelector('model-viewer');
            if (modelViewer) {
              this.params.noSwiping = !modelViewer.classList.contains('shopify-model-viewer-ui__disabled');
              this.params.noSwipingClass = 'swiper-slide';
            }
          },
        },
      });
    }

    showActiveMedia() {
      const mediaId = this.openedBy.getAttribute('data-media-id');
      const activePopup = this.querySelector('.js-popup-slider:not(.hidden)');
      if (!activePopup || !activePopup.swiper) return;

      // Scroll popup to the clicked image's slide
      const imgEl = activePopup.querySelector(`[data-media-id="${mediaId}"]`);
      if (imgEl) {
        const slideEl = imgEl.closest('.swiper-slide');
        if (slideEl) {
          const index = Array.from(activePopup.swiper.slides).indexOf(slideEl);
          if (index >= 0) activePopup.swiper.slideTo(index, 0);
        }
      }

      // Load deferred YouTube media if needed
      const deferredMedia = activePopup.querySelector(`deferred-media[data-media-id="${mediaId}"]`);
      if (deferredMedia && deferredMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        deferredMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-risers"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.syncActiveGallery();
      this.showActiveMedia();
    }

    // Find which gallery is currently active in the main product area
    getActiveMainGallery() {
      return document.querySelector('.product__media-wrapper .js-media-list-ab-test:not(.hidden)');
    }

    // Show the popup slider that matches the active main gallery; init its Swiper if needed
    syncActiveGallery() {
      const activeMainGallery = this.getActiveMainGallery();
      const popupSliders = Array.from(this.querySelectorAll('.js-popup-slider'));

      // Hide all popup sliders
      popupSliders.forEach(s => s.classList.add('hidden'));

      let targetPopup = null;

      if (activeMainGallery) {
        const galleryId = activeMainGallery.dataset.jsMediaListId;
        targetPopup = this.querySelector(`.js-popup-slider[data-js-media-list-id="${galleryId}"]`);
      }

      if (!targetPopup) {
        targetPopup = this.querySelector('.js-popup-slider-default');
      }

      if (!targetPopup) return;

      targetPopup.classList.remove('hidden');
      this.initPopupSlider(targetPopup, activeMainGallery);
    }

    initPopupSlider(elem, mainGallery) {
      if (elem.swiper) {
        elem.swiper.update();
        if (mainGallery && mainGallery.swiper) {
          elem.swiper.slideTo(mainGallery.swiper.activeIndex, 0);
        }
        return;
      }

      new Swiper(elem, {
        slidesPerView: 1,
        navigation: {
          nextEl: '.product-media-modal .product__slider-nav .swiper-button-next',
          prevEl: '.product-media-modal .product__slider-nav .swiper-button-prev',
        },
        pagination: {
          el: '.product-media-modal .product__pagination',
          type: 'bullets',
          clickable: true,
        },
        on: {
          afterInit: (swiper) => {
            if (mainGallery && mainGallery.swiper) {
              swiper.slideTo(mainGallery.swiper.activeIndex, 0);
            }
          },
          slideChange: function() {
            window.pauseAllMedia();
            this.params.noSwiping = false;
            this.el.classList.remove('zoom');
          },
          touchMove: function() {
            this.el.classList.remove('zoom');
          },
          slideChangeTransitionEnd: function() {
            const modelViewer = this.slides[this.activeIndex]?.querySelector('model-viewer');
            if (modelViewer) {
              modelViewer.querySelector('.shopify-model-viewer-ui__button--poster')?.removeAttribute('hidden');
            }
          },
          touchStart: function() {
            const modelViewer = this.slides[this.activeIndex]?.querySelector('model-viewer');
            if (modelViewer) {
              this.params.noSwiping = !modelViewer.classList.contains('shopify-model-viewer-ui__disabled');
              this.params.noSwipingClass = 'swiper-slide';
            }
          },
        },
      });
    }

    showActiveMedia() {
      const mediaId = this.openedBy.getAttribute('data-media-id');
      const activePopup = this.querySelector('.js-popup-slider:not(.hidden)');
      if (!activePopup || !activePopup.swiper) return;

      // Scroll popup to the clicked image's slide
      const imgEl = activePopup.querySelector(`[data-media-id="${mediaId}"]`);
      if (imgEl) {
        const slideEl = imgEl.closest('.swiper-slide');
        if (slideEl) {
          const index = Array.from(activePopup.swiper.slides).indexOf(slideEl);
          if (index >= 0) activePopup.swiper.slideTo(index, 0);
        }
      }

      // Load deferred YouTube media if needed
      const deferredMedia = activePopup.querySelector(`deferred-media[data-media-id="${mediaId}"]`);
      if (deferredMedia && deferredMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        deferredMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["not-main-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
